import { render, staticRenderFns } from "./ProductizeTransformedAttributeDetail.vue?vue&type=template&id=56d8ad87&scoped=true"
import script from "./ProductizeTransformedAttributeDetail.vue?vue&type=script&lang=js"
export * from "./ProductizeTransformedAttributeDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d8ad87",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56d8ad87')) {
      api.createRecord('56d8ad87', component.options)
    } else {
      api.reload('56d8ad87', component.options)
    }
    module.hot.accept("./ProductizeTransformedAttributeDetail.vue?vue&type=template&id=56d8ad87&scoped=true", function () {
      api.rerender('56d8ad87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/attributes/modules/use_cases/ProductizeTransformedAttributeDetail.vue"
export default component.exports